import { create } from './create';
import getList from './getList';

export type { CreateError } from './create';

export default {
	getList,
	create
};
